export default Object.freeze({
  timberWallsRoom: {
    configurable: true,
    label: "Timber Walls (Room)",
    coats: 3,
  },
  timberWall: {
    configurable: true,
    label: "Timber Wall",
    coats: 3,
  },
  timberDoor: {
    configurable: true,
    label: "Timber Door",
    coats: 3,
  },
  benchTop: {
    configurable: true,
    label: "Bench Top",
    coats: 3,
  },
  smallTable: {
    configurable: false,
    label: "Small Table",
    coats: 3,
  },
  largeTable: {
    configurable: false,
    label: "Large Table",
    coats: 3,
  },
  diningTable: {
    configurable: false,
    label: "Dining Table and Chairs",
    coats: 3,
  },
  miscFurniture: {
    configurable: true,
    label: "Miscellaneous Furniture",
    coats: 3,
  },
  concreteFloor: {
    configurable: true,
    label: "Concrete Floor",
    coats: 1,
  },
  floorHouse: {
    configurable: true,
    label: "Floor (House)",
    coats: 2,
  },
  floorRoom: {
    configurable: true,
    label: "Floor (Room)",
    coats: 2,
  },
  cladding: {
    configurable: true,
    label: "Cladding",
    coats: 2,
  },
  deck: {
    configurable: true,
    label: "Deck",
    coats: 3,
  },
  windows: {
    configurable: true,
    label: "Windows",
    coats: 2,
  },
  outdoorFurniture: {
    configurable: true,
    label: "Outdoor Furniture",
    coats: 3,
  },
});

export const fixedLiterages = {
  smallTable: 0.5,
  largeTable: 1,
  diningTable: 2,
};

// Key is square meterage, second is literage
export const usageRanges = {
  0: 0,
  6.25: 0.5,
  12.5: 1,
  25: 2,
  50: 4,
  62: 5,
  75: 6,
  125: 10,
  150: 12,
  175: 14,
  250: 20,
  300: 24,
  375: 30,
  500: 40,
  625: 50,
  750: 60,
  875: 70,
  1000: 80,
};
